import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import AlertIcon from "assets/icons/alert.svg";
import { useNavigate } from "react-router-dom";
import { fareharborModalStyles } from "styles/IntegrationDirectory/fareharborModal.styles";

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: { xs: "90%", sm: "500px" },
  width: { xs: "90%", sm: "500px" },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
  margin: "0px 0px",
  p: { xs: 1, md: 2 },
};

interface ModalProps {
  open: boolean;
  close: () => void;
}

export default function FHSuccesModal({ open, close }: ModalProps) {
  const navigate = useNavigate();
  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="customer-modal-title"
      aria-describedby="customer-modal-description"
    >
      <Box sx={{ ...style }}>
        <Box sx={fareharborModalStyles.headerContainer}>
          <Typography variant="h6" fontWeight={600}>
            Import Completed!
          </Typography>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography sx={fareharborModalStyles.mainText}>
          Go to the Items section and assign a category type and commission rate
          to each item.
        </Typography>

        <Box sx={fareharborModalStyles.bodyContainer}>
          <img src={AlertIcon} alt="alert" />
          <Typography sx={fareharborModalStyles.mainText}>
            Go to the Items section and assign a category type and commission
            rate to each item.
          </Typography>
        </Box>
        <Box sx={fareharborModalStyles.buttonContainer}>
          <Button
            variant="contained"
            sx={fareharborModalStyles.actionBtn}
            onClick={() => navigate("/my-items")}
          >
            My Items
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
